import i18n from "../i18n";

const getGuideTypeLabel = (key) =>
  i18n.t(`coaching-portal:guidesActions.guideType_${key}`);

const Guides = (app) => {
  app
    .post("/guides/save", async ({ api, flash, req, res }) => {
      const { body, files } = req;
      let meal = false;
      let supplement = false;
      let resource = false;

      Object.keys(files).forEach((file) => {
        if (file === "meal-file") {
          meal = true;
        }
        if (file === "supplement-file") {
          supplement = true;
        }
        if (file === "resource-pdf" || file === "image" || body.url) {
          resource = true;
        }
      });

      if (body.url) {
        resource = true;
      }

      const uploaded = [];
      if (meal) uploaded.push("meal");
      if (supplement) uploaded.push("supplement");
      if (resource) uploaded.push("resource");

      const documentsUploaded = uploaded.length ? uploaded.join("_") : "none";

      const saveGuides = await api(`athlete-guides`, {
        method: "POST",
        body,
        files,
      });
      flash(
        "success",
        i18n.t("coaching-portal:guidesActions.savedSuccessfully", {
          type: getGuideTypeLabel(documentsUploaded),
        })
      );
      res.backDontScroll();
    })
    .post("/guides/remove", async ({ api, assert, flash, req, res, load }) => {
      const { body } = req;
      const { athleteId, type, id } = body;

      const saveGuides = await api(
        `athlete-guides?athleteId=${athleteId}&type=${type}&id=${id}`,
        {
          method: "DELETE",
        }
      );

      flash(
        "success",
        i18n.t("coaching-portal:guidesActions.successfullyDeleted")
      );
      res.refreshWith(
        {
          "modal[type]": "",
          thumbnail: "",
        },
        { url: "back", hash: "#_" }
      );
    })
    .post("/guides/save/:resourceId", async ({ api, flash, req, res }) => {
      const { body, files } = req;

      console.log("running? xd", body, files);

      if (body.url) {
        //if the user don't edit the image
        if (Object.keys(files).length === 0) {
          delete body.file;

          await api(`athlete-guides/`, {
            method: "PUT",
            body,
          });
        }
        //if the user edit the image
        else {
          await api(`athlete-guides/`, {
            method: "PUT",
            body,
            files,
          });
        }
      } else {
        delete body["resource-pdf"];

        delete body.file;
        await api(`athlete-guides`, {
          method: "PUT",
          body,
          files,
        });
      }

      flash(
        "success",
        i18n.t("coaching-portal:guidesActions.resourceUpdatedSuccessfully")
      );
      res.backDontScroll();
    });
};

export default Guides;
